import { render, staticRenderFns } from "./ChatHeader.vue?vue&type=template&id=34695204&scoped=true&"
import script from "./ChatHeader.vue?vue&type=script&lang=ts&"
export * from "./ChatHeader.vue?vue&type=script&lang=ts&"
import style0 from "./ChatHeader.vue?vue&type=style&index=0&id=34695204&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34695204",
  null
  
)

export default component.exports